import ACTIONS from "./DashboardActionTypes";

const initialState = {
  //CARD
  getDashboardCardLoading: false,
  getDashboardCardResponse: null,
  //PIE
  getDashboardPieEmployeeLoading: false,
  getDashboardPieEmployeeResponse: null,
  getDashboardPieStatusLoading: false,
  getDashboardPieStatusResponse: null,
  getDashboardPieGroupByPurposeLoading: false,
  getDashboardPieGroupByPurposeResponse: null,
  getDashboardPieCreatedByLoading: false,
  getDashboardPieCreatedByResponse: null,
  //LINE
  getDashboardLineMonthlyLoading: false,
  getDashboardLineMonthlyResponse: null,
  getDashboardLineYearlyLoading: false,
  getDashboardLineYearlyResponse: null,
};

const DashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    //CARD
    case ACTIONS.GET_DASHBOARD_CARD_REQUEST:
      return {
        ...state,
        getDashboardCardLoading: true,
      };
    case ACTIONS.GET_DASHBOARD_CARD_RESPONSE:
      return {
        ...state,
        getDashboardCardLoading: false,
        getDashboardCardResponse: action.payload,
      };
    //PIE
    case ACTIONS.GET_DASHBOARD_PIE_EMPLOYEE_REQUEST:
      return {
        ...state,
        getDashboardPieEmployeeLoading: true,
      };
    case ACTIONS.GET_DASHBOARD_PIE_EMPLOYEE_RESPONSE:
      return {
        ...state,
        getDashboardPieEmployeeLoading: false,
        getDashboardPieEmployeeResponse: action.payload,
      };
    case ACTIONS.GET_DASHBOARD_PIE_STATUS_REQUEST:
      return {
        ...state,
        getDashboardPieStatusLoading: true,
      };
    case ACTIONS.GET_DASHBOARD_PIE_STATUS_RESPONSE:
      return {
        ...state,
        getDashboardPieStatusLoading: false,
        getDashboardPieStatusResponse: action.payload,
      };
    case ACTIONS.GET_DASHBOARD_PIE_GROUPBY_PURPOSE_OF_REQUEST:
      return {
        ...state,
        getDashboardPieGroupByPurposeLoading: true,
      };
    case ACTIONS.GET_DASHBOARD_PIE_GROUPBY_PURPOSE_OF_RESPONSE:
      return {
        ...state,
        getDashboardPieGroupByPurposeLoading: false,
        getDashboardPieGroupByPurposeResponse: action.payload,
      };
    case ACTIONS.GET_DASHBOARD_PIE_CREATED_BY_REQUEST:
      return {
        ...state,
        getDashboardPieCreatedByLoading: true,
      };
    case ACTIONS.GET_DASHBOARD_PIE_CREATED_BY_RESPONSE:
      return {
        ...state,
        getDashboardPieCreatedByLoading: false,
        getDashboardPieCreatedByResponse: action.payload,
      };
    //LINE
    case ACTIONS.GET_DASHBOARD_LINE_CHART_MONTHLY_REQUEST:
      return {
        ...state,
        getDashboardLineMonthlyLoading: true,
      };
    case ACTIONS.GET_DASHBOARD_LINE_CHART_MONTHLY_RESPONSE:
      return {
        ...state,
        getDashboardLineMonthlyLoading: false,
        getDashboardLineMonthlyResponse: action.payload,
      };
    case ACTIONS.GET_DASHBOARD_LINE_CHART_YEARLY_REQUEST:
      return {
        ...state,
        getDashboardLineYearlyLoading: true,
      };
    case ACTIONS.GET_DASHBOARD_LINE_CHART_YEARLY_RESPONSE:
      return {
        ...state,
        getDashboardLineYearlyLoading: false,
        getDashboardLineYearlyResponse: action.payload,
      };
    default:
      return state;
  }
};

export default DashboardReducer;
